var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import merge from 'lodash-es/merge';
import * as qs from 'qs';
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { ChartParams } from "app/views/chart/chart.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { FilterParams } from "../../models/filter_form.model";
import { ModalService } from "../../views/modal/base_modal.component";
import { MailDetailComponent } from "./mail_detail.component";
import { MailService } from "app/mails/mail.service";
import { HttpClient } from "@angular/common/http";
import { HelperService } from "../../lib/helper.service";
import dictionaries from "../../../dict/static.json";
import { from, of } from "rxjs";
import { catchError, concatMap, map, switchMap, tap, toArray } from "rxjs/operators";
function getGAName(name) {
    return name + "-GA";
}
var MailRow = /** @class */ (function () {
    function MailRow(chart, name) {
        this.chart = chart;
        this.name = name;
        this._isShowSent = true;
        this._isShowReaded = false;
    }
    MailRow.prototype.toogleChart = function (name) {
        this.chart.options.$toggle.next(name);
    };
    Object.defineProperty(MailRow.prototype, "isShowSent", {
        get: function () { return this._isShowSent; },
        set: function (value) {
            this._isShowSent = value;
            this.toogleChart(this.name);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailRow.prototype, "isShowReaded", {
        get: function () { return this._isShowReaded; },
        set: function (value) {
            this._isShowReaded = value;
            this.toogleChart(getGAName(this.name));
        },
        enumerable: true,
        configurable: true
    });
    return MailRow;
}());
var MailCategoryModel = /** @class */ (function () {
    function MailCategoryModel(data) {
        this.name = 'category 1';
        this.chart = new ChartParams({
            isChartFilter: true
        });
        this.table = [];
        this.titlePrintType = 'name';
        this.setData(data);
    }
    MailCategoryModel.prototype.setData = function (data) {
        var _this = this;
        this.name = data.name;
        this.chart.data = data.charts;
        merge(this.chart.options, data.options);
        this.chart.options.filter.datePeriodList = [];
        var table = data.table || [];
        this.chart.options.showLabels = table;
        this.chart.options.lazyRender = ['domain', 'paids', 'badges'].includes(data.name);
        this.table = table.map(function (r) { return new MailRow(_this.chart, r); });
    };
    return MailCategoryModel;
}());
var mailGroups = dictionaries.mailGroups;
var MailComponent = /** @class */ (function (_super) {
    __extends(MailComponent, _super);
    function MailComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, helper, mailService) {
        var _this = _super.call(this, eventsService, mailService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.mailService = mailService;
        // по дефолту мы не учитываем в отправках домен яндекса, потому что прочтения по ним не приходят в ga
        _this.defaultEmailFilter = 'allExceptYandex';
        _this.addFilterParams = {
            dateFilters: ['dateSentMail'],
            email: _this.defaultEmailFilter,
        };
        _this.totalLoader = false;
        _this.totalSent = 0;
        _this.totalNoSent = 0;
        _this.stats = [];
        _this.names = {};
        _this.subjects = [];
        _this.chartPeriod = '30days';
        _this.tabs = mailGroups.map(function (m) { return m.tab; });
        _this.tab = 'main';
        _this.i18nForSubject = {};
        _this.subjectTypeConfig = {
            config: {
                valueField: 'subjectType',
                labelField: ['i18n', 'subjectType'],
                searchField: ['subjectType', 'i18n'],
                render: {
                    option: function (item) {
                        return "<div>" + item.i18n + " (" + item.subjectType + ")</div>";
                    },
                    item: function (item) {
                        return "<div>" + item.i18n + " (" + item.subjectType + ")</div>";
                    },
                },
                maxItems: 16,
            },
            options: null
        };
        var me = _this;
        me.i18nForSubject['name'] = 'Тема';
        me.i18nForSubject['service name'] = 'subjectType';
        var subjects = {};
        me.names = mailGroups.reduce(function (names, tab) {
            tab.groups.forEach(function (group) {
                group.subjectTypes.forEach(function (subjectType) {
                    names[subjectType] = me.__a('mails.mail.' + subjectType);
                    names[getGAName(subjectType)] = getGAName(me.__a('mails.mail.' + subjectType));
                    subjects[names[subjectType]] = subjectType;
                });
            });
            return names;
        }, {});
        me.subjects = Object.keys(subjects)
            .map(function (i18n) { return ({ i18n: i18n, subjectType: subjects[i18n], }); });
        me.subjectTypeConfig.options = me.subjects;
        return _this;
    }
    MailComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp;
            return __generator(this, function (_a) {
                me = this;
                fp = me.filter.filterParams;
                me.tab = fp.tab;
                if (me.$s) {
                    me.$s.unsubscribe();
                    me.$s = null;
                }
                me.$s = of(fp)
                    .pipe(
                // Общие цифры
                tap(function () { return me.totalLoader = true; }), switchMap(function () { return me.mailService.mail.total(fp); }), map(function (_a) {
                    var totalSent = _a.totalSent, totalNoSent = _a.totalNoSent;
                    me.totalSent = totalSent;
                    me.totalNoSent = totalNoSent;
                    me.totalLoader = true;
                    // Список графиков
                    // TODO Подумать как всё таки вызвать явно destroy у c3js instance-а
                    me.stats = me.getChartList();
                }), switchMap(function () { return from(me.stats).pipe(concatMap(function (stat) {
                    stat.chart.showLoader();
                    return me.mailService.mail.chart(__assign({}, fp, { categoryName: stat.name }))
                        .pipe(map(function (data) { return stat.setData(data); }), tap(function () { return stat.chart.hideLoader(); }));
                }), toArray()); }), catchError(function (err) {
                    me.eventsService.broadcast('mail-error', err);
                    throw err;
                }))
                    .subscribe(function () {
                    console.log('mail load end', me.stats.length);
                });
                return [2 /*return*/];
            });
        });
    };
    MailComponent.prototype.applyFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, paramsAsStr;
            return __generator(this, function (_a) {
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params['tab'] = this.tab;
                paramsAsStr = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + paramsAsStr, { relativeTo: this.activatedRoute });
                return [2 /*return*/];
            });
        });
    };
    MailComponent.prototype.resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams = new FilterParams();
                this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = merge({}, this.filter.getDiffParams(this.filter.filterParams)), url = this.router.url.split('?')[0];
                delete params.dateFilters;
                delete params.dateFilterParams;
                this.router.navigate([url], { relativeTo: this.activatedRoute, queryParams: params });
                return [2 /*return*/];
            });
        });
    };
    MailComponent.prototype.changeTitleForChart = function (stat, titlePrintType) {
        stat.titlePrintType = titlePrintType;
        if (stat.titlePrintType === 'name') {
            stat.chart.setOptions({ names: this.names });
        }
        else {
            stat.chart.setOptions({ names: null });
            stat.chart.setOptions({ names: {} });
        }
    };
    MailComponent.prototype.updateData = function (filter, categoryName) {
        return __awaiter(this, void 0, void 0, function () {
            var me, filterParams, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this, filterParams = merge({}, me.filter.filterParams, filter);
                        return [4 /*yield*/, me.mailService.mail.chart(__assign({}, filterParams, { categoryName: categoryName })).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.stats.forEach(function (stat) {
                            if (stat.name === categoryName) {
                                stat.chart.data = charts;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MailComponent.prototype.showTable = function (stat) {
        return __awaiter(this, void 0, void 0, function () {
            var me, modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this, modalRef = me.modalService.open(MailDetailComponent, {
                            title: stat.name,
                            isLoad: true,
                        }, { size: 'hg' });
                        return [4 /*yield*/, me.mailService.mail.detail(__assign({}, me.filter.filterParams, { categoryName: stat.name })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.stats = stats;
                        modalRef.componentInstance.isLoad = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MailComponent.prototype.getChartList = function () {
        var me = this;
        var tab = mailGroups.find(function (tab) { return me.tab === tab.tab; });
        // UPDATE:
        // Тут такое нужно, поскольку про группу "total" вкладки main - знает только код тут, на клиенте.
        // А на беке, и в других отчётах группа total не нужна.
        if (me.tab === 'main' && tab.groups[0].group !== 'total') {
            tab.groups.unshift({
                group: "total",
                subjectTypes: ['sent', 'noSent']
            });
        }
        // По факту мы проходимся по списку графиков два раза.
        // Это сделано для того, чтобы развязать по времени:
        // 1. инициализацию графика
        // 2. хождение за данными
        // 3. построение графика по данным
        // Иначе браузер не вывозит отрисовку страницы
        var stats = [];
        for (var _i = 0, _a = tab.groups; _i < _a.length; _i++) {
            var chart = _a[_i];
            var stat = new MailCategoryModel({
                name: chart.group,
                options: {
                    names: me.names,
                },
            });
            if (chart.group === 'total') {
                stat.chart.setOptions({
                    axes: {
                        sent: 'y',
                        noSent: 'y2',
                    },
                    axis: {
                        y: {
                            min: 1,
                            ticks: 5,
                            label: {
                                text: 'sent',
                                position: 'outer-middle'
                            }
                        },
                        y2: {
                            show: true,
                            label: {
                                text: 'noSent',
                                position: 'outer-middle'
                            }
                        }
                    },
                    names: me.names,
                });
            }
            stats.push(stat);
        }
        return stats;
    };
    MailComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.stats = [];
    };
    return MailComponent;
}(BaseComponent));
export { MailComponent };
